import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import PlayButton from './play-button.svg';

import './video.less';

const formatTime = (timeInSeconds) => {
  const minutes = Math.round(timeInSeconds / 60);
  const seconds = Math.round(timeInSeconds % 60);
  return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};

/* eslint-disable jsx-a11y/media-has-caption */
// A customized video component used in setup guide.
// These typically will not have any soundtrack
const Video = ({ src, poster }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTimeLine, setcurrentTimeLine] = useState(0);
  const videoRef = useRef(null);
  const timelineRef = useRef(null);

  const onPlay = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const onEnded = () => {
    setIsPlaying(false);
    videoRef.current.load();
  };

  const getTimeLeft = () => {
    const { duration, currentTime } = videoRef.current;
    return `${formatTime(currentTime)} / ${formatTime(duration)}`;
  };

  const onTimeUpdate = () => {
    const { currentTime, duration } = videoRef.current;
    const percentagePosition = (100 * currentTime) / duration;
    if (timelineRef && timelineRef.current) {
      timelineRef.current.style.backgroundSize = `${percentagePosition}% 100%`;
    }
    setcurrentTimeLine(percentagePosition);
  };

  const onChangeTime = (e) => {
    const { value } = e.target;
    const { duration } = videoRef.current;
    const updatedTime = (value * duration) / 100;
    videoRef.current.currentTime = updatedTime;
  };

  const onMouseDown = () => {
    videoRef.current.pause();
  };

  const onMouseUp = () => {
    videoRef.current.play();
  };

  return (
    <div className={`video-player ${isPlaying ? 'playing' : ''}`}>
      <video
        id='video'
        onClick={onPlay}
        onEnded={onEnded}
        ref={videoRef}
        onTimeUpdate={onTimeUpdate}
        poster={poster}>
        <source src={src} type='video/mp4' />
      </video>
      <div className='controls'>
        {!isPlaying && (
          <button className='play-button control-button clearButton' onClick={onPlay}>
            <PlayButton className='clearSvg' />
          </button>
        )}
        {isPlaying && (
          <div className='timeline-container'>
            <span className='time'>{getTimeLeft()}</span>
            <input
              type='range'
              min='0'
              max='100'
              className='timeline'
              onMouseDown={onMouseDown}
              onMouseUp={onMouseUp}
              onInput={onChangeTime}
              value={currentTimeLine}
              ref={timelineRef} />
          </div>
        )}

      </div>
    </div>
  );
};

Video.propTypes = {
  src: PropTypes.string.isRequired,
  poster: PropTypes.string,
};

Video.defaultProps = {
  poster: null,
};

export default Video;



// WEBPACK FOOTER //
// ./app/components/support/video.jsx